import React, { FunctionComponent, memo } from "react";
import { Box, Button } from "@mui/material";

import { EsgAnomalyWarning, NewTabIcon } from "assets";
import { getUtilityBillById } from "api";
import { setToLocalStorage } from "utils";

import { UTILITY_BILL_PAGE } from "../../../route-consts";
import { AnomalyProps } from "./types";

export const Anomaly: FunctionComponent<AnomalyProps> = memo(
  ({
    anomalyType,
    message,
    bgColor = "#E215151A",
    previousBillGuid,
    notify,
  }) => {
    const handlePreviousBillCardClick = async (id: string) => {
      if (id) {
        try {
          const response = await getUtilityBillById(id);
          setToLocalStorage(
            "document",
            JSON.stringify({
              documentGuid: response.documentGuid,
              filename: response.filename,
            }),
          );

          window.open(`${UTILITY_BILL_PAGE.ABSOLUTE_PATH(previousBillGuid as string)}`, "_blank");
        } catch (error) {
          console.error("Error fetching utility bill:", error);
          notify?.error("This bill no longer exists. It may have been deleted.");
        }
      }
    };

    return (
      <Box sx={{
        bgcolor: bgColor,
        borderRadius: "4px",
        padding: previousBillGuid ? "0px 0px 24px 16px" : "24px 0px 24px 16px",
        width: "584px"
      }}
      >
        <Box sx={{
          display: "flex",
          flexDirection: "column",
        }}>
          <Box sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}>
            {previousBillGuid && (
              <Button
                sx={{
                  minWidth: "24px",
                  height: "24px",
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                  paddingRight: "4px",
                }}
                onClick={() => handlePreviousBillCardClick(previousBillGuid as string)}
              >
                <NewTabIcon />
              </Button>
            )}
          </Box>
          <Box sx={{
            display: "flex",
            gap: "10px",
            paddingRight: "24px",
            marginBottom: 0,
            marginLeft: "10px",
            "& > h3": {
              margin: 0,
              fontWeight: "600",
              fontSize: "14px",
            },
          }}>
            <EsgAnomalyWarning />
            <h3>Verification Failed | {anomalyType}</h3>
          </Box>
        </Box>
        <ul style={{
          fontSize: "12px",
          fontWeight: "500",
          paddingInlineStart: "25px",
          paddingRight: "24px",
          marginBottom: 0,
        }}>
          <li style={{
            textWrap: "wrap",
            marginBottom: "8px",
          }}>{message}</li>
          <li style={{
            textWrap: "wrap",
          }}>
            Please <span style={{ color: "#E21515" }}>review the data</span> and make any necessary corrections, or click &quot;Confirm Data&quot; if everything is accurate.</li>
        </ul>
      </Box >
    );
  },
);
